import React, {useState, useRef, useEffect} from 'react';
import styles from './MediaPopup.module.css';

const MediaPopup = ({isOpen, type, src, onClose}) => {
    if (!isOpen) return null;

    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        // Reset when source changes
        setIsPlaying(false);
    }, [src]);

    const togglePlay = e => {
        e.stopPropagation();
        const v = videoRef.current;
        if (!v) return;
        if (v.paused) {
            v.play();
            setIsPlaying(true);
        } else {
            v.pause();
            setIsPlaying(false);
        }
    };

    return (
        <div className={styles['media-popup']} onClick={onClose} role="dialog" aria-modal="true">
            <div
                className={type === 'image' ? styles['image-popup__content'] : styles['video-popup__content']}
                onClick={e => e.stopPropagation()}>
                <button className={styles['media-popup__close']} onClick={onClose} aria-label="Close">
                    <img src="/bw_image/close-2.svg" alt="" aria-hidden="true" />
                </button>

                {type === 'image' ? (
                    <img src={src} alt="popup" className={styles['media-popup__image']} />
                ) : (
                    <div
                        className={styles['media-popup__video-wrapper']}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}>
                        <video
                            ref={videoRef}
                            src={src}
                            playsInline
                            className={styles['media-popup__video']}
                            onClick={togglePlay}
                            onPlay={() => setIsPlaying(true)}
                            onPause={() => setIsPlaying(false)}
                        />
                        {(!isPlaying || isHovered) && (
                            <button
                                type="button"
                                className={styles['media-popup__play-btn']}
                                onClick={togglePlay}
                                aria-label={isPlaying ? 'Pause video' : 'Play video'}>
                                {isPlaying ? (
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                        <circle cx="32" cy="32" r="32" fill="#006940" />
                                        <rect x="24" y="18" width="6" height="28" fill="#fff" />
                                        <rect x="34" y="18" width="6" height="28" fill="#fff" />
                                    </svg>
                                ) : (
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                        <circle cx="32" cy="32" r="32" fill="#006940" />
                                        <polygon points="26,20 46,32 26,44" fill="#fff" />
                                    </svg>
                                )}
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MediaPopup;
